"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SmartCal;
const FormulaInterpreter_1 = require("../interpreter/FormulaInterpreter");
const FormulaParser_1 = require("../parser/FormulaParser");
const FormulaTokenizer_1 = require("../tokenizer/FormulaTokenizer");
/**
 * Evaluates a mathematical expression and returns the result.
 *
 * This function parses and interprets a mathematical formula represented as a string,
 * applying dynamic values from a given object to resolve variables or conditions within the expression.
 *
 * @template T - A generic type representing the structure of the input object. Keys are variable names, and values can be numbers, strings, or arrays.
 * @param {string} expression - The mathematical expression to be evaluated.
 *        Variables in the expression should correspond to keys in the `obj` parameter.
 * @param {T} obj - An object containing the values of the variables referenced in the expression.
 * @returns {number | string | any[]} - The result of the evaluated expression, which can be a number, a string, or an array depending on the expression's logic.
 */
function SmartCal(expression, obj) {
    const fTokenizer = new FormulaTokenizer_1.FormulaTokenizer();
    const fParser = new FormulaParser_1.FormulaParser();
    const fInterpreter = new FormulaInterpreter_1.FormulaInterpreter();
    return fInterpreter.execute(fParser.execute(fTokenizer.execute(expression)), obj || {});
}
